import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<circle cx="12" cy="12" r="10" fill="transparent" key="0" />,<path fill="currentColor" d="M11.9998 1.9998c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10m-2 15-5-5 1.41-1.41 3.59 3.58 7.59-7.59 1.41 1.42z" key="1" />,]
, 'DisplayConfirmedCircleFilledx');
